const route = [
    {
        path: '/activity/2024happy/index', //2023下期末检测
        component: function (resolve) {
            require(['VIEWS/activity/2024happy/index.vue'], resolve);
        }
    },
]
export default route;
